import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment, UrlMatchResult } from '@angular/router';
import { CmsEditoComponent } from './cms-edito.component';

export const EDITO_PREFIX = 'journal';

export function cmsPageEditoUrlMatcher(url: UrlSegment[]): UrlMatchResult | null {
  if (url.length > 0 && url[0].path === EDITO_PREFIX) {
    return { consumed: url };
  }
  return null;
}

const cmsRoutes: Routes = [
  {
    path: '',
    component: CmsEditoComponent,
    data: {
      pageAnalytics: {
        env_template: 'edito'
      }
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(cmsRoutes)],
  exports: [RouterModule]
})
export class CmsEditoRoutingModule {}
